import { useSearchParams } from 'react-router';

export const TRANSUNION_REFERRAL_ID = 'transunion';

export const useReferralId = () => {
  const [searchParams] = useSearchParams();
  const referralId = searchParams.get('referralId');

  const isTransunionReferral = referralId?.toLowerCase() === TRANSUNION_REFERRAL_ID;

  return {
    referralId,
    isTransunionReferral,
  };
};
